import Login from 'features/Auth/Login/Login.component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(auth)/_auth/login')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Login />;
}
